export function swapDynamicText(str: string, keys: Record<string, string>) {
    for (const [k, v] of Object.entries(keys)) {
        const t = `{{ ${k} }}`;
        /** If the string doesn't contain the key, return an empty string so we don't show janky UI */
        if (!str.includes(t)) {
            return '';
        }
        str = str.replace(t, v);
    }
    return str;
}
